import { Components } from "appworks/components/components";
import { State } from "appworks/state-machine/states/state";
import { FowlEggPickBonusComponent } from "components/bonus/pick/fowl-egg-pick-bonus-component";

export class FowlPickBonusState extends State {
    public onEnter(): void {
        // enable pick buttons
        const eggPickBonus = Components.get(FowlEggPickBonusComponent);
        eggPickBonus.enablePicks();
        // listen for game end
        eggPickBonus.gameEnd.addOnce(() => this.complete());
    }
}
